import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/Common/Card';
import Table from '../../components/Common/Table';
import api from '../../utils/api';
import { showDeleteConfirm, showSuccess, showError } from '../../utils/swal';

const SaleList = () => {
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSales();
  }, []);

  const fetchSales = async () => {
    try {
      const response = await api.get('/sales');
      setSales(response.data.data || response.data);
      setLoading(false);
    } catch (error) {
      console.error('Satışlar yüklenemedi:', error);
      setLoading(false);
    }
  };

  const handleDelete = async (row) => {
    const customerName = `${row.customer?.name} ${row.customer?.surname}`;
    const result = await showDeleteConfirm(`${customerName} müşterisine ait satış`);

    if (!result.isConfirmed) {
      return;
    }

    try {
      await api.delete(`/sales/${row.id}`);
      showSuccess('Satış başarıyla silindi');
      fetchSales();
    } catch (error) {
      console.error('Satış silinemedi:', error);
      showError('Satış silinirken bir hata oluştu');
    }
  };

  const columns = [
    {
      header: 'Satışı Yapan Görevli',
      accessor: 'user',
      render: (row) => row.user?.name || '-'
    },
    {
      header: 'Müşteri',
      render: (row) => (
        <span
          className="text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer font-medium"
          onClick={(e) => {
            e.stopPropagation();
            if (row.customer?.id) navigate(`/customers/${row.customer.id}`);
          }}
        >
          {`${row.customer?.name || ''} ${row.customer?.surname || ''}`.trim() || '-'}
        </span>
      )
    },
    {
      header: 'Satışı Yapılan Gayrimenkul',
      accessor: 'portfolio',
      render: (row) => (
        <span
          className="text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer font-medium"
          onClick={(e) => {
            e.stopPropagation();
            if (row.portfolio?.id) navigate(`/portfolios/${row.portfolio.id}`);
          }}
        >
          {row.portfolio?.title || '-'}
        </span>
      )
    },
    {
      header: 'Satış Fiyatı',
      accessor: 'final_sale_price',
      render: (row) => row.final_sale_price ? `${row.final_sale_price.toLocaleString('tr-TR')} ₺` : '-'
    },
    {
      header: 'Satış Tarihi',
      accessor: 'sale_date',
      render: (row) => row.sale_date ? new Date(row.sale_date).toLocaleDateString('tr-TR') : '-'
    },
    {
      header: 'Sözleşme Tarihi',
      accessor: 'contract_date',
      render: (row) => row.contract_date ? new Date(row.contract_date).toLocaleDateString('tr-TR') : '-'
    },
  ];

  if (loading) {
    return <div className="text-center py-8">Yükleniyor...</div>;
  }

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-800 dark:text-white mb-6">Geçmiş Satışlar</h1>

      <Card noPadding>
        <Table
          columns={columns}
          data={sales}
          onView={(row) => navigate(`/portfolios/${row.portfolio?.id}`)}
          onDelete={handleDelete}
        />
      </Card>
    </div>
  );
};

export default SaleList;
